import { render, staticRenderFns } from "./Footer-Wx.vue?vue&type=template&id=41398cb4&scoped=true&"
import script from "./Footer-Wx.vue?vue&type=script&lang=js&"
export * from "./Footer-Wx.vue?vue&type=script&lang=js&"
import style0 from "./Footer-Wx.vue?vue&type=style&index=0&id=41398cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41398cb4",
  null
  
)

export default component.exports